import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import Loader from "components/Loader/Loader";
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import { toast } from 'react-toastify'; 
// const useStyles = makeStyles(() => ({
//     container: {
//         position: "relative",
//         width: "420px",
//         height: "150px",
//         margin: "40px auto",
//         background: "#fff",
//         border: "1px solid #ddd",
//         borderRadius: "10px",
//         boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//         overflow: "hidden",
//     },
//     svg: {
//         width: "100%",
//         height: "100%",
//     },
//     path: {
//         fill: "none",
//         stroke: "#2C3345",
//         strokeWidth: 2,
//         strokeDasharray: 800,
//         strokeDashoffset: 800,
//         animation: "$draw 4s ease-in-out forwards",
//     },
//     pen: {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         animation: "$movePen 4s ease-in-out forwards",
//         offsetPath: `path("M30,100 C70,30 120,90 160,40 S250,90 280,70 Q310,100 340,60 T390,90")`,
//         offsetDistance: "0%",
//         offsetRotate: "auto",
//     },
//     "@keyframes draw": {
//         to: { strokeDashoffset: 0 },
//     },
//     "@keyframes movePen": {
//         "0%": {
//             offsetDistance: "0%",
//             opacity: 1,
//         },
//         "100%": {
//             offsetDistance: "100%",
//             opacity: 1,
//         },
//     },
// }));

// function ScribbledSignatureLoader() {
//     const classes = useStyles();
//     const penRef = useRef(null);

//     useEffect(() => {
//         const pen = penRef.current;
//         if (pen) {
//             pen.style.offsetPath =
//                 'path("M30,100 C70,30 120,90 160,40 S250,90 280,70 Q310,100 340,60 T390,90")';
//         }
//     }, []);

//     return (
//         <div className={classes.container}>
//             <svg viewBox="0 0 420 150" className={classes.svg}>
//                 <path
//                     d="M30,100 C70,30 120,90 160,40 S250,90 280,70 Q310,100 340,60 T390,90"
//                     className={classes.path}
//                 />
//             </svg>
//             <div ref={penRef} className={classes.pen}>
//                 <EditIcon style={{ color: "#2C3345", fontSize: 26 }} />
//             </div>
//         </div>
//     );
// }


const Preview = ({ formData, formFields, setNext,links }) => {
    const [loader, setLoader] = useState(true);
    const { getsericepluscreation } = upgardeloyalty();

    console.log(formData)

    console.log(formFields)
    console.log(localStorage.getItem('countryname'),"country")

    let country = localStorage.getItem('countryname')

    const [ThriveServiceplus, setThriveServiceplus] = useState("");
  const [ThriveServiceplusprivacy, setThriveServiceplusprivacy] = useState("");
  const [ThriveServiceplustermcondition, setThriveServiceplustermcondition] = useState("");


  useEffect(()=>{
    setThriveServiceplus(links?.triveserviceplusLink)
    setThriveServiceplusprivacy(links?.thriveserviceplusprivacyLink)
    setThriveServiceplustermcondition(links?.thriveserviceplustermconditionLink)

  },[])

    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 0)
    }, [])

    const today = new Date().toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
    });

    const handlecreate = async () => {
      
  
       
          try {
            
              let values = {
                    data: formData,
                  country: country
              };
              let res = await getsericepluscreation(values);
            
              
              if (res.result_status == 0) {
                return toast.error(res.message);
            }
            else{
              return toast.success(res.message);

            }
          }
          catch (err) {
              console.log({ err });
          }
      };

    return (
        <div className="preview-wrapper">
            {!loader ? <div className="preview-container">
                <div className="preview-header">
                    <span className="date">{today}</span>
                    <h2>
                        Complete the Form Below to Enroll in Henry Schein Thrive Service Plus
                    </h2>
                </div>

                <div className="preview-body">
                    {formFields.map((field, index) => (
                        <div className="row" key={index}>
                            <strong>{field.label}</strong>
                            <span className={(field.key === "title") || (field.key === "tier") || (field.key === "state") ? "tag" : ""}>
                                {formData[field.key] || "-"}
                            </span>
                        </div>
                    ))}
                </div>
                <div style={{ fontSize: "13px", color: "#333", lineHeight: "1.5", padding: 40 }}>
                    <p>
                        By clicking the <strong>"Enroll"</strong> button below, You agree: (i) to place this order and agree to the related terms electronically, and (ii) to the terms and conditions of the{" "}
                        <a
                            href={ThriveServiceplus}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1a0dab", textDecoration: "underline" }}
                        >
                            Thrive Service Plus Agreement.
                        </a>
                        For more information,Please read our <a style={{ textDecoration: "underline" ,color: "#1a0dab",}} href={ThriveServiceplusprivacy} target="_blank"
                                    rel="noopener noreferrer"> Privacy Statement.  </a>
                    </p>
                    <p>
                        Placing this order also includes your acceptance and agreement to our program{" "}
                        <a
                            href={ThriveServiceplustermcondition}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1a0dab", textDecoration: "underline" }}
                        >
                            Terms and Conditions.
                        </a>{" "}
                        Please read them before placing this order.
                    </p>
                    <div><strong>Signature</strong></div>
                    <img src={formData?.signature} alt="" />
                </div>
                <div
                    style={{
                        textAlign: "center",
                        color: "#333",
                        padding: "40px",
                    }}
                >
                    <p
                        style={{
                            fontSize: "14px",
                            marginBottom: "12px",
                        }}
                    >
                        I understand and accept that my electronic signature will be as valid as a handwritten
                        signature and considered original to the extent allowed by applicable law.
                    </p>
                    <button
                        style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            padding: "10px 24px",
                            fontSize: "14px",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "bold",
                        }}
                        onClick={() => {
                            setNext('6');
                            handlecreate();
                          }}
                    >
                        Sign Document
                    </button>
                </div>

                <style>{`

        .preview-wrapper {
            padding: 10px;
        }

        .preview-container {
          max-width: 679px;
          margin: 40px auto;
        //   padding: 30px;
          background: #ffffff;
          border: 1px solid #ddd;
          font-family: 'Segoe UI', sans-serif;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }

        .preview-header {
          background: #f1f4ff;
          padding: 40px 40px 10px 40px;
          margin-bottom: 30px;
          position: relative;
        //   text-align: center;
        }

        .preview-header .date {
          position: absolute;
          top: 10px;
          right: 20px;
          font-size: 14px;
          color: #555;
        }

        .preview-header h2 {
          font-size: 20px;
          color: #222;
          margin-top: 20px;
        }

        .preview-body {
          padding: 0 40px;
        }

        .row {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid #eee;
        }

        .row strong {
          flex: 1;
          font-weight: 600;
          color: #333;
        }

        .row span {
          flex: 2;
          text-align: left;
          color: #444;
        }

        .tag {
          display: inline-block;
          background: #e0e7ff;
          color: #1a237e;
          padding: 4px 12px;
          border-radius: 6px;
          font-weight: 500;
          width: fit-content;
        }
      `}</style>
            </div> : <div style={{ height: "100vh", display: "flex", alignItems: "center" }}><Loader /></div>}
        </div>
    );
};

export default Preview;